import * as React from "react"
import LatestPost from "../components/LatestPost"
import { useStaticQuery, graphql } from "gatsby"

export default function LatestPosts() {

  const data = useStaticQuery(graphql`
    query {
      allWpPost(limit: 5) {
        nodes {
          id
          title
          link
        }
      }
    }
  `)

  return (
    <div className="mt-4r">
      <p className="fw-700 mb-2r">Últimos Posts</p>
      {
        data.allWpPost.nodes.map(node => (
          <LatestPost to={node.link} text={node.title} btnClass="dt" key={node.id} />
        ))
      }
    </div>
  )
}